import apiClient from './apiClient';
import { TizhiTrendResponse, TizhiProbability, TizhiSyncResponse } from '../types';

export interface TizhiTrackResponse {
  predicted_label: string;
  confidence: number;
  probabilities: TizhiProbability[];
  alert?: string | null;
  history_count?: number;
}

export interface TizhiRecord {
  id: number;
  predicted_label: string;
  confidence: string;
  probabilities: TizhiProbability[];
  input_text?: string;
  created_at: string;
}

export async function trackTizhi(payload: { text: string; top_k?: number }): Promise<TizhiTrackResponse> {
  const response = await apiClient.post<TizhiTrackResponse>('/tizhi/track', payload);
  return response.data;
}

export async function fetchTizhiHistory(params?: { limit?: number; offset?: number }): Promise<TizhiRecord[]> {
  const response = await apiClient.get<TizhiRecord[]>('/tizhi/history', { params });
  return response.data;
}

export async function fetchTizhiTrend(params?: { days?: number }): Promise<TizhiTrendResponse> {
  const response = await apiClient.get<TizhiTrendResponse>('/tizhi/trend', { params });
  return response.data;
}

export async function syncTizhiFromMedicalRecords(payload?: { record_ids?: number[]; force?: boolean }): Promise<TizhiSyncResponse> {
  const response = await apiClient.post<TizhiSyncResponse>('/tizhi/sync-medical-records', payload ?? {});
  return response.data;
}
